/*
  Pre-checked cart upsell (e.g. shipping protection).
  - When the cart drawer is open and holds other products, the upsell is added automatically.
  - Customers can switch it off; that choice is remembered for the rest of their visit.
  - If the upsell is the only thing left in the cart, it is removed.
  Markup comes from snippets/cart-primary-upsell.liquid (data-preselected-upsell).
*/
(function () {
  var OPT_OUT_KEY = 'cartPreselectedUpsellOptOut';
  var busy = false;
  var addFailed = false;
  var checkTimer;

  function optedOut() {
    try {
      return window.sessionStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setOptedOut(value) {
    try {
      if (value) window.sessionStorage.setItem(OPT_OUT_KEY, '1');
      else window.sessionStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCard() {
    return document.querySelector('#CartDrawer [data-preselected-upsell]');
  }

  function drawerIsOpen() {
    var drawer = getDrawer();
    return !!drawer && drawer.classList.contains('active');
  }

  function postCart(url, body) {
    var drawer = getDrawer();
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    body.sections = sections.join(',');
    body.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function render(state) {
    var drawer = getDrawer();
    if (state && state.sections && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      return true;
    }
    return false;
  }

  function addUpsell(card) {
    busy = true;
    card.classList.add('is-updating');
    return postCart(window.routes.cart_add_url + '.js', {
      items: [{ id: Number(card.dataset.variantId), quantity: 1 }]
    })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Could not add item');
        if (!render(state)) throw new Error('Cart drawer could not refresh');
      })
      .catch(function (error) {
        addFailed = true;
        card.classList.remove('is-updating');
        var input = card.querySelector('[data-preselected-upsell-toggle]');
        if (input) input.checked = false;
        console.error(error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function removeUpsell(card) {
    var updates = {};
    (card.dataset.lineKeys || '').split(',').forEach(function (key) {
      if (key) updates[key] = 0;
    });
    if (Object.keys(updates).length === 0) return Promise.resolve();

    busy = true;
    card.classList.add('is-updating');
    return postCart(window.routes.cart_update_url + '.js', { updates: updates })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Could not remove item');
        if (!render(state)) throw new Error('Cart drawer could not refresh');
      })
      .catch(function (error) {
        card.classList.remove('is-updating');
        var input = card.querySelector('[data-preselected-upsell-toggle]');
        if (input) input.checked = true;
        console.error(error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function check() {
    if (busy || !drawerIsOpen()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var card = getCard();
    if (!card) return;

    var inCart = card.dataset.inCart === 'true';
    var otherItems = parseInt(card.dataset.otherItems, 10) || 0;

    if (inCart && otherItems === 0) {
      removeUpsell(card);
    } else if (!inCart && otherItems > 0 && !optedOut() && !addFailed && card.dataset.available === 'true') {
      addUpsell(card);
    }
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(check, 100);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-preselected-upsell-toggle]')) return;
    var card = input.closest('[data-preselected-upsell]');
    if (!card || busy) {
      input.checked = !input.checked;
      return;
    }

    if (input.checked) {
      setOptedOut(false);
      addFailed = false;
      addUpsell(card);
    } else {
      setOptedOut(true);
      removeUpsell(card);
    }
  });

  function init() {
    var drawer = getDrawer();
    var drawerContent = document.getElementById('CartDrawer');
    if (!drawer || !drawerContent) return;

    // Re-check whenever the drawer re-renders (item added, quantity changed, etc.)
    new MutationObserver(scheduleCheck).observe(drawerContent, { childList: true, subtree: true });

    // ...and whenever it opens.
    new MutationObserver(function () {
      if (drawerIsOpen()) scheduleCheck();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
